/**
 * @generated SignedSource<<5b8da5dc09f27f897732a731572d6cff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveActionItemsBannerMutation$variables = {
  days: number;
};
export type ArchiveActionItemsBannerMutation$data = {
  readonly archiveActionItems: {
    readonly updatedBlocks: ReadonlyArray<{
      readonly done: boolean;
      readonly id: string;
      readonly key: string;
      readonly text: string;
    }>;
  } | null;
};
export type ArchiveActionItemsBannerMutation = {
  response: ArchiveActionItemsBannerMutation$data;
  variables: ArchiveActionItemsBannerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "days"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "createdFromDays",
        "variableName": "days"
      }
    ],
    "concreteType": "ArchiveActionItems",
    "kind": "LinkedField",
    "name": "archiveActionItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlocks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "done",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveActionItemsBannerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchiveActionItemsBannerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39406d4adf97e85714a1fc0fb4893a42",
    "id": null,
    "metadata": {},
    "name": "ArchiveActionItemsBannerMutation",
    "operationKind": "mutation",
    "text": "mutation ArchiveActionItemsBannerMutation(\n  $days: Int!\n) {\n  archiveActionItems(createdFromDays: $days) {\n    updatedBlocks {\n      id\n      key\n      text\n      done\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b68e2ffcde0a8d7ae2eb5b17a8cb2e42";

export default node;
